module.exports = __webpack_public_path__ + "static/img/end.03be981.png";


//////////////////
// WEBPACK FOOTER
// ./src/public/images/end.png
// module id = 1pEJ
// module chunks = 1